import React from 'react';
import { printables, themes } from '../data/content';
import { SectionHeading } from './SectionHeading';
import { ImageCarousel } from './ImageCarousel';
const dots = ['bg-coral', 'bg-gold', 'bg-leaf', 'bg-navy'];
export function Gallery() {
  return <section id="inside" aria-labelledby="inside-title" className="bg-cream" data-id="element-131" data-mp="3ia544p39pxre">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 lg:py-28" data-id="element-132" data-mp="3ddo52zuj5yzj">
        <SectionHeading id="inside-title" title="Look Inside the Gospel Sharing Mega Bundle" intro="This isn’t a collection of a few repeated messages. Inside, you’ll find 200+ Bible verses across 20+ different Gospel-sharing designs — a wide variety of Scripture-centered messages to print, cut and share." data-id="element-133" data-mp="2pmsjwlkky219" />
        <div className="-mx-5 mt-10 sm:-mx-8" data-id="element-134" data-mp="2ukk8p6pxh818">
          <ImageCarousel items={printables} label="Printable Gospel designs" data-id="element-135" data-mp="26waq0do0h0eb" />
        </div>

        <div className="mt-16 grid items-center gap-10 rounded-[28px] bg-gold-wash p-8 sm:p-10 lg:grid-cols-[1fr_1.4fr]" data-id="element-136" data-mp="21yhjtkmpk6e1">
          <div data-id="element-137" data-mp="rbrquvbg6b48">
            <p className="text-lg font-bold text-navy" data-id="element-138" data-mp="rcay9i3h1h40">You’ll find verses and messages about:</p>
            <p className="mt-6 font-display text-[28px] leading-tight text-navy sm:text-[34px]" data-id="element-139" data-mp="wa2ycze9s9ja">
              Choose the message that fits the moment.
              <span className="mt-1 block italic text-coral" data-id="element-140" data-mp="154hf76eg7s4i">Print it. Cut it. And share it.</span>
            </p>
          </div>
          <ul className="flex flex-wrap gap-3" aria-label="Message themes" data-id="element-141" data-mp="8f0bgwz10g5g">
            {themes.map((t, i) => <li key={t} className="inline-flex items-center gap-2.5 rounded-full bg-white px-5 py-3 font-bold text-navy shadow-card" data-id="element-142" data-mp="ddbiz11umeki" data-mpi={i}>
                <span className={`h-2.5 w-2.5 rounded-full ${dots[i % dots.length]}`} aria-hidden="true" data-id="element-143" data-mp="mdgikp0sw8o4" />
                {t}
              </li>)}
            <li className="inline-flex items-center px-3 py-3 font-bold italic text-ink-soft" data-id="element-144" data-mp="1st0l5fa0zstf">…and more.</li>
          </ul>
        </div>
      </div>
    </section>;
}